module.exports = __webpack_public_path__ + "img/attendance-gift.3b60361.png";